export enum WirelessSensorPairingStatus {
  DeviceNotAdded = 0,
  Initializing,
  GettingDetails,
  Finalizing,
  Done,
  Unknown
}
